import React, { PureComponent } from 'react';

class TablaRowEdicion extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ajuste, backColor, siNoConfirmacion } = this.props;

        let periodoActual = ajuste.Aplica;
        let referencia = ajuste.Referencia;
        let fechaDeIngreso = ajuste.FechaIngreso != null ? ajuste.FechaIngreso.substring(8,10) + '-' + ajuste.FechaIngreso.substring(5,7) + '-' + ajuste.FechaIngreso.substring(0,4) : null;
        let usuarioDeIngreso = ajuste.UsuarioIngreso;
        let sucursal = ajuste.Sucursal;
        let origen = ajuste.Origen;
        let fechaUltimaModificacion = ajuste.FechaUltModif != null ? ajuste.FechaUltModif.substring(8,10) + '-' + ajuste.FechaUltModif.substring(5,7) + '-' + ajuste.FechaUltModif.substring(0,4) : null;
        let usuarioDeModificacion = ajuste.UsuarioModificacion;
        let fechaEnvioProcesador = ajuste.FechaEnvioProcesador;
        let usuarioConfirmacion = ajuste.UsuarioConfirmacion;
        let fechaConfirmacion = ajuste.FechaConfirmacion;
        let habilitaConfirmacionAjuste = ajuste.TipoMovimiento == 'A' && siNoConfirmacion[0].SINOCONFIRMACIONAJUSTES && origen == "Manual Individual AD17" ? true : false;
        let habilitaConfirmacionCargo = ajuste.TipoMovimiento == 'C' && siNoConfirmacion[0].SINOCONFIRMACIONCARGOS && origen == "Manual Individual AD17" ? true : false;
        let motivoRechazo = ajuste.MotivoRechazo;

        let backColor1 = backColor;
        let backColor2 = backColor1 != '' ? 'row-child-style' : ' backgroundTableLightBlue';


        return (
            <tr>
                <div className="no-padding">
                    <div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Aplica:</label>
                            <label className="col-md-7">{periodoActual ? periodoActual : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor2}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Tarjeta:</label>
                            <label className="col-md-7">-</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Referencia:</label>
                            <label className="col-md-7">{referencia ? referencia : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor2}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Sucursal</label>
                            <label className="col-md-7">{sucursal ? sucursal : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Origen:</label>
                            <label className="col-md-7">{origen ? origen : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor2}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha de ingreso:</label>
                            <label className="col-md-7">{fechaDeIngreso ? fechaDeIngreso : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Usuario de ingreso:</label>
                            <label className="col-md-7">{usuarioDeIngreso ? usuarioDeIngreso : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor2}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha última modificación:</label>
                            <label className="col-md-7">{fechaUltimaModificacion ? fechaUltimaModificacion : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Usuario de modificación</label>
                            <label className="col-md-7">{usuarioDeModificacion ? usuarioDeModificacion : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor2}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Fecha de envío a Procesador:</label>
                            <label className="col-md-7">{fechaEnvioProcesador ? fechaEnvioProcesador : "-"}</label>
                        </div>
                        <div className={'row ingresoAjustesTableRow ' + backColor1}>
                            <label className="col-md-1"></label>
                            <label className="col-md-4">Motivo del Rechazo:</label>
                            <label className="col-md-7">{motivoRechazo ? motivoRechazo : "-"}</label>
                        </div>
                        {habilitaConfirmacionAjuste ? 
                            <div className={'row ingresoAjustesTableRow ' + backColor2}>
                                <label className="col-md-1"></label>
                                <label className="col-md-4">Usuario Confirmación:</label>
                                <label className="col-md-7">{usuarioConfirmacion ? usuarioConfirmacion : "-"}</label>
                            </div>
                         : null}
                        {habilitaConfirmacionAjuste ? 
                            <div className={'row ingresoAjustesTableRow ' + backColor1}>
                                <label className="col-md-1"></label>
                                <label className="col-md-4">Fecha Confirmación:</label>
                                <label className="col-md-7">{fechaConfirmacion ? fechaConfirmacion : "-"}</label>
                            </div>
                         : null}
                        {habilitaConfirmacionCargo ? 
                            <div className={'row ingresoAjustesTableRow ' + backColor2}>
                                <label className="col-md-1"></label>
                                <label className="col-md-4">Usuario Confirmación:</label>
                                <label className="col-md-7">{usuarioConfirmacion ? usuarioConfirmacion : "-"}</label>
                            </div>
                         : null}
                        {habilitaConfirmacionCargo ? 
                            <div className={'row ingresoAjustesTableRow ' + backColor1}>
                                <label className="col-md-1"></label>
                                <label className="col-md-4">Fecha Confirmación:</label>
                                <label className="col-md-7">{fechaConfirmacion ? fechaConfirmacion : "-"}</label>
                            </div>
                         : null}
                    </div>
                </div>
            </tr>);
    }
}

export default TablaRowEdicion;